import React, { useEffect, useState } from 'react';
import { Card, Table } from 'react-bootstrap';
import { Pagination } from '../../../shared/components/Pagination';
import TableSkeleton, { ITableColumn } from '../../../shared/components/TableSkeleton';
import { IPackageLog } from '../../../model/package/IPackage';
import { PackagesService } from '../PackagesService';
import { formatDate } from '../../../utils/Functions';
import { ErrorToast } from '../../../utils/toasters';
import { FaCheck, FaTimes } from 'react-icons/fa';

const LOG_COLUMNS: ITableColumn[] = [
    { label: 'ID' },
    { label: 'Date' },
    { label: 'Package' },
    { label: 'Company' },
    { label: 'Trial' },
    { label: 'Changed by' },
];

export default function PackagesLog() {
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 20,
    });
    const [totalPages, setTotalPages] = useState(0);
    const [packagesList, setPackagesList] = useState<Partial<IPackageLog>[]>([]);
    const [dataLoading, setDataLoading] = useState(true);

    useEffect(() => {
        setDataLoading(true);
        PackagesService.getPackagesLog(pagination)
            .then(data => {
                setPackagesList(data.data);
                setTotalPages(Math.ceil(data.count / pagination.perPage));
            })
            .catch(err => ErrorToast(err))
            .finally(() => setDataLoading(false));
    }, [pagination]);

    const handlePages = (updatePage: number) => {
        setPagination({ ...pagination, page: updatePage });
    };

    const renderTrial = (v: boolean | undefined) => (
        <span className={`word-break ${v ? 'text-primary' : 'text-danger'}`}>{v ? <FaCheck /> : <FaTimes />}</span>
    );

    return (
        <Card className="mb-5 p-4 mt-5">
            {dataLoading ? (
                <TableSkeleton columns={LOG_COLUMNS} rows={pagination.perPage} />
            ) : (
                <Table hover responsive>
                    <thead>
                        <tr>
                            {LOG_COLUMNS.map(column => (
                                <th key={column.label} className={column.className}>
                                    {column.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {packagesList.map(item => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{formatDate(item?.createdAt as string)}</td>
                                <td>{item.package?.displayName}</td>
                                <td>
                                    <span className="text-primary">({item.company?.id})</span>{' '}
                                    {item.company?.displayName}
                                </td>
                                <td>{renderTrial(item.isTrial)}</td>
                                <td className="text-left">{item.changedBy?.email}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )}

            <Pagination
                page={pagination.page}
                totalPages={totalPages}
                handlePagination={handlePages}
                disabled={dataLoading}
            />
        </Card>
    );
}
